import React, {useMemo} from 'react';
import {Col, Row} from 'react-bootstrap';

import {ActivityFeedTimeStamp} from './ActivityFeedTimeStamp';
import {ActivityFeedValueDeltaDisplay} from "./ActivityFeedValueDeltaDisplay";
import {parseActivityData} from "../../../Utils/Activity/parseActivityData";

export const ActivityFeedItem = props => {
    const {
        title: ActivityTitleComponent,
        description,
        secondaryDescription: RightSection,
        Event: contextNodeActivity = {}
    } = props;
    const {Activity: activity = null} = contextNodeActivity;

    // Derived, not state: parsing in an effect rendered one frame with an empty object first, so a
    // line stating a count from the data ("12 survey answers") flashed "0 survey answers" before the
    // effect landed. The dependency stays the raw `data` string, since the parse allocates a new
    // object each time and the parsed value cannot be compared by identity.
    const customData = useMemo(() => parseActivityData(activity), [activity?.data]);

    const renderSecondaryDescription = () => {
        // use provided
        if(RightSection) {
            return <RightSection CustomEventData={customData} Event={contextNodeActivity} />
        }

        // default if we have deltas
        if(customData.newValue !== undefined
            && customData.oldValue !== undefined
            && customData.viewer != null
        ) {
            return <ActivityFeedValueDeltaDisplay
                NewValue={customData.newValue}
                OldValue={customData.oldValue}
                NewData={customData.newData}
                OldData={customData.oldData}
                FieldCustomData={customData.fieldCustomData}
                Viewer={customData.viewer}
            />;
        }

        return null;

    }

    const renderTitle = () => {
        return <h4 className="sb-activity-feed-group-item-summary-title">
            <ActivityTitleComponent {...{contextNodeActivity}} />
        </h4>;
    }

    const renderDescription = () => {
        if(description != null) {
            return <props.description CustomEventData={customData} Event={contextNodeActivity} />
        }
        return null
    }

    const renderTimeStamp = () => {
        return <ActivityFeedTimeStamp Event={contextNodeActivity} />
    }


    let secondaryDescription = renderSecondaryDescription();

    if(secondaryDescription != null) {
        return <Row className="sb-activity-feed-group-item">
            <Col xs={8} className="sb-activity-feed-group-item-summary">
                {renderTitle()}
                {renderDescription()}
                {renderTimeStamp()}
            </Col>
            <Col xs={4} className="sb-activity-feed-group-item-view">
                {secondaryDescription}
            </Col>
        </Row>
    }

    return <Row className="sb-activity-feed-group-item">
        <Col xs={12} className="sb-activity-feed-group-item-summary">
            {renderTitle()}
            {renderDescription()}
            {renderTimeStamp()}
        </Col>
    </Row>;

}



